import {
  AppBar,
  Autocomplete,
  Box,
  CircularProgress,
  Paper,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import "./index.css";
import ApiService from "../../utils/fetch";
import { useNavigate } from "react-router-dom";

const AnalyticsPage = () => {
  const navigate = useNavigate();
  const [reportId, setReportId] = useState(null);
  const [embedUrl, setEmbedUrl] = useState(null);
  const [pageName, setPageName] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [reportName, setReportName] = useState("Operational Metrics");
  const [oppSubReportName, setOppSubReportName] = useState("Safety Stock Adherence");
  const [loading, setLoading] = useState(true);

  const commonGroupId = "f17d276a-7d2b-4eac-ba8a-8b9fba2365e5"
  const CountofSafetyStockMasterDataGroupId = "be3acc5f-bfe8-42da-8a07-3ff5cccc1bb3"

  const oppsafetyStockAdheranceReportId = "c1ed549b-44fd-4cb3-a6bf-39f29db56a8c";
  //prod
  const oppLOTAdherenceReportId = "c5d0b4cb-927f-4827-87c0-aff2329f6b19";
  //dev
  //const oppLOTAdherenceReportId = "c7b925fc-35b2-46ca-90b0-8c8ca46673f7";
  const oppForecastAccuracyEastReportId = "29c37b5f-2016-439a-98fd-a59ed302e116";
  const oppForecastAccuracyWestReportId = "20cf7aaf-8449-4cce-900c-152ff5df7bfa";

  const fillRateAdherenceSummaryReportId = "5ae04b44-4f0a-43f7-a637-12a59ca76950";
  const fillRateAdherenceDetailsReportId = "5ae04b44-4f0a-43f7-a637-12a59ca76950";

  const oppsafetyStockAdherancePageId = "58f40fb5f47a06d566ff";
  const oppLOTAdherencePageId = "8816368586ea2e60355e";
  const fillRateAdherenceSummaryPageId = "b376b8a9e97e6026cc2f"
  const fillRateAdherenceDetailsPageId = "3aecba08d0bc8e30fb86"

  const oppForecastAccuracyEastPageId = "23ac2a03d6cf11441f40";
  const oppForecastAccuracyWestPageId = "ReportSection744efd0aca22ce5ba447";

  //for Dev Adoption metrics
  //  const AdoptionSSCPSCountofMaterialsReportID = "69f67bfc-a95c-43ef-9357-a8704b1450cc";
  //  const AdoptionSSCPSValueofSafetyStockReportID = "69f67bfc-a95c-43ef-9357-a8704b1450cc"
  //  const AdoptionSafetyStockValueDifferenceIORecommendationvsFinalSSReportID = "69f67bfc-a95c-43ef-9357-a8704b1450cc"
  //  const AdoptionCountofSafetyStockMasterDataChangesMadeDirectlyinS4ReportID = "3da79c86-a00d-47f2-8ed9-16fef459f58f"

  //for Prod Adoption metrics
  const AdoptionSSCPSCountofMaterialsReportID = "fc444f7f-9878-4418-922f-a86ff6df7d9d";
  const AdoptionSSCPSValueofSafetyStockReportID = "fc444f7f-9878-4418-922f-a86ff6df7d9d"
  const AdoptionSafetyStockValueDifferenceIORecommendationvsFinalSSReportID = "fc444f7f-9878-4418-922f-a86ff6df7d9d"
  const AdoptionCountofSafetyStockMasterDataChangesMadeDirectlyinS4ReportID = "3da79c86-a00d-47f2-8ed9-16fef459f58f"

  //For future purpose.. not for dev and prod
  
  // const AdoptionSSCPSCountofMaterialsGroupID = "f17d276a-7d2b-4eac-ba8a-8b9fba2365e5";
  // const AdoptionSSCPSValueofSafetyStockGroupID = "f17d276a-7d2b-4eac-ba8a-8b9fba2365e5";
  // const AdoptionSafetyStockValueDifferenceIORecommendationvsFinalSSGroupID = "f17d276a-7d2b-4eac-ba8a-8b9fba2365e5";
  // const AdoptionCountofSafetyStockMasterDataChangesMadeDirectlyinS4GroupID = "be3acc5f-bfe8-42da-8a07-3ff5cccc1bb3";

  const AdoptionSSCPSCountofMaterialsPageID = "95a6cd7c78db50e7381e";
  const AdoptionSSCPSValueofSafetyStockPageID = "7ca2014b8923c802529d";
  const AdoptionSafetyStockValueDifferenceIORecommendationvsFinalSSPageID = "d5bcdc0b93274cc11e87";
  const AdoptionCountofSafetyStockMasterDataChangesMadeDirectlyinS4PageID = "";

  useEffect(() => {
    if (!reportName) return;

    const fetchReportData = async () => {
      setLoading(true);

      const reportIdAxios = oppSubReportName === "Safety Stock Adherence" ? oppsafetyStockAdheranceReportId : oppSubReportName === "Lot Adherence" ? oppLOTAdherenceReportId : oppSubReportName === "Fill Rate Adherence Summary" ? fillRateAdherenceSummaryReportId : oppSubReportName === "Fill Rate Adherence Details" ? fillRateAdherenceDetailsReportId : oppSubReportName === "Forecast Accuracy East" ? oppForecastAccuracyEastReportId : oppSubReportName === "Forecast Accuracy West" ? oppForecastAccuracyWestReportId : oppSubReportName === "SSCPS Count of Materials" ? AdoptionSSCPSCountofMaterialsReportID : oppSubReportName === "SSCPS Value of Safety Stock" ? AdoptionSSCPSValueofSafetyStockReportID : oppSubReportName === "Safety Stock Value Difference" ?
        AdoptionSafetyStockValueDifferenceIORecommendationvsFinalSSReportID : oppSubReportName === "Count of Safety Stock Master Data" ? AdoptionCountofSafetyStockMasterDataChangesMadeDirectlyinS4ReportID : ""

      const choosePageName = oppSubReportName === "Safety Stock Adherence" ? oppsafetyStockAdherancePageId : oppSubReportName === "Lot Adherence" ? oppLOTAdherencePageId : oppSubReportName === "Fill Rate Adherence Summary" ? fillRateAdherenceSummaryPageId : oppSubReportName === "Fill Rate Adherence Details" ? fillRateAdherenceDetailsPageId : oppSubReportName === "Forecast Accuracy East" ? oppForecastAccuracyEastPageId : oppSubReportName === "Forecast Accuracy West" ? oppForecastAccuracyWestPageId : oppSubReportName === "SSCPS Count of Materials" ? AdoptionSSCPSCountofMaterialsPageID : oppSubReportName === "SSCPS Value of Safety Stock" ? AdoptionSSCPSValueofSafetyStockPageID : oppSubReportName === "Safety Stock Value Difference" ?
        AdoptionSafetyStockValueDifferenceIORecommendationvsFinalSSPageID : oppSubReportName === "Count of Safety Stock Master Data" ? "" : ""

      //for Dev
      //const chooseGroupId = (oppSubReportName === "Count of Safety Stock Master Data" || oppSubReportName === "Fill Rate Adherence Summary" || oppSubReportName === "Fill Rate Adherence Details" || oppSubReportName === "Forecast Accuracy East" || oppSubReportName === "Forecast Accuracy West") ? CountofSafetyStockMasterDataGroupId : commonGroupId;

      //For Prod
      const chooseGroupId = CountofSafetyStockMasterDataGroupId;

      try {
        const response = await ApiService.get(`/powerBI/embedDetails/group/${chooseGroupId}/report/${reportIdAxios}`, { name: reportName });
        const data = response.data;
        setEmbedUrl(data.embedUrl || null);
        setAccessToken(data.accessToken || null);
        setReportId(data.reportId);
        setPageName(choosePageName);
      } catch (error) {
        console.error("Report fetch failed", error);
        setReportId(null);
        setEmbedUrl(null);
        setAccessToken(null);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [oppSubReportName]);

  const embedConfig = {
    type: "report",
    id: reportId,
    embedUrl: `${embedUrl?.split("&pageName=")[0]}&pageName=${pageName}`,
    accessToken: accessToken,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      navContentPaneEnabled: false,
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.FitToWidth,
      },
    },
  };

  const onChangeReportName = (name) => {
    if (name === "Adoption Metrics") {
      setOppSubReportName("SSCPS Count of Materials")
    }
    else {
      setOppSubReportName("Safety Stock Adherence")
    }
    setReportName(name)
  }

  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          marginTop: "18px",
        }}
      >
        <AppBar position="static" elevation={1} color="default">
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Typography sx={{ fontWeight: 600, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <p style={{ cursor: 'pointer', fontWeight: 'normal', marginRight: 5 }} onClick={() => navigate("/inventory-optimization")}>{"Back >"}</p>
              KPI Metrics
            </Typography>
          </Toolbar>
        </AppBar>
        <div style={{ display: 'flex' }}>
          <div onClick={() => onChangeReportName("Operational Metrics")}
            style={{
              flex: 1, fontWeight: reportName === "Operational Metrics" ? "bold" : "normal", background: reportName === "Operational Metrics" ? "#fff" : "#bcbcbc", textAlign: 'center', cursor: 'pointer'
            }}><p>Operational Metrics</p></div>
          <div onClick={() => onChangeReportName("Adoption Metrics")} style={{ flex: 1, fontWeight: reportName === "Adoption Metrics" ? "bold" : "normal", background: reportName === "Adoption Metrics" ? "#fff" : "#bcbcbc", textAlign: 'center', cursor: 'pointer' }}><p>Adoption Metrics</p></div>
        </div>
        <div style={{ border: '1px solid #bcbcbc', margin: 10 }}>
          {reportName === "Operational Metrics" ?
            <div style={{ display: 'flex', margin: 10 }}>
              <div onClick={() => setOppSubReportName("Safety Stock Adherence")} style={{ flex: 1, borderRadius: oppSubReportName === "Safety Stock Adherence" ? "50px" : "0px", border: oppSubReportName === "Safety Stock Adherence" ? "2px solid #000" : "1px solid #fff", textAlign: 'center', cursor: 'pointer' }}>
                <p >Safety Stock Adherence</p>
              </div>
              <div onClick={() => setOppSubReportName("Lot Adherence")} style={{ flex: 1, borderRadius: oppSubReportName === "Lot Adherence" ? "50px" : "0px", border: oppSubReportName === "Lot Adherence" ? "2px solid #000" : "1px solid #fff", textAlign: 'center', cursor: 'pointer' }}>
                <p>Lot Size Adherence</p>
              </div>

              <div onClick={() => setOppSubReportName("Fill Rate Adherence Summary")} style={{ flex: 1, borderRadius: (oppSubReportName === "Fill Rate Adherence Summary" || oppSubReportName === "Fill Rate Adherence Details") ? "50px" : "0px", border: oppSubReportName === "Fill Rate Adherence Summary" || oppSubReportName === "Fill Rate Adherence Details" ? "2px solid #000" : "1px solid #fff", textAlign: 'center', cursor: 'pointer' }}>
                <p>Fill Rate Adherence</p>
                {(oppSubReportName === "Fill Rate Adherence Summary" || oppSubReportName === "Fill Rate Adherence Details") &&
                  <div style={{ display: 'flex', marginBottom: 5 }}>
                    <div onClick={(e) => {
                      e.stopPropagation();
                      setOppSubReportName("Fill Rate Adherence Summary");
                    }}
                      style={{ flex: 1, textDecoration: oppSubReportName === "Fill Rate Adherence Summary" ? "underline" : "none", textAlign: 'center', cursor: 'pointer' }}>
                      Summary
                    </div>
                    <div onClick={(e) => {
                      e.stopPropagation();
                      setOppSubReportName("Fill Rate Adherence Details");
                    }}
                      style={{ flex: 1, textDecoration: oppSubReportName === "Fill Rate Adherence Details" ? "underline" : "none", textAlign: 'center', cursor: 'pointer' }}>
                      Details
                    </div>
                  </div>}
              </div>

              <div onClick={() => setOppSubReportName("Forecast Accuracy East")} style={{ flex: 1, borderRadius: oppSubReportName === "Forecast Accuracy East" || oppSubReportName === "Forecast Accuracy West" ? "50px" : "0px", border: oppSubReportName === "Forecast Accuracy East" || oppSubReportName === "Forecast Accuracy West" ? "2px solid #000" : "1px solid #fff", textAlign: 'center', cursor: 'pointer' }}>
                <p>Forecast Accuracy</p>
                {(oppSubReportName === "Forecast Accuracy East" || oppSubReportName === "Forecast Accuracy West") &&
                  <div style={{ display: 'flex', marginBottom: 5 }}>
                    <div onClick={(e) => {
                      e.stopPropagation();
                      setOppSubReportName("Forecast Accuracy East");
                    }}
                      style={{ flex: 1, textDecoration: oppSubReportName === "Forecast Accuracy East" ? "underline" : "none", textAlign: 'center', cursor: 'pointer' }}>
                      East
                    </div>
                    <div onClick={(e) => {
                      e.stopPropagation();
                      setOppSubReportName("Forecast Accuracy West");
                    }}
                      style={{ flex: 1, textDecoration: oppSubReportName === "Forecast Accuracy West" ? "underline" : "none", textAlign: 'center', cursor: 'pointer' }}>
                      West
                    </div>
                  </div>}
              </div>
            </div>
            :
            <div style={{ display: 'flex', margin: 10 }}>
              <div onClick={() => setOppSubReportName("SSCPS Count of Materials")} style={{ flex: 1, borderRadius: oppSubReportName === "SSCPS Count of Materials" ? "50px" : "0px", border: oppSubReportName === "SSCPS Count of Materials" ? "2px solid #000" : "1px solid #fff", textAlign: 'center', cursor: 'pointer' }}>
                <p>SS by Source – Materials</p>
              </div>
              <div onClick={() => setOppSubReportName("SSCPS Value of Safety Stock")} style={{ flex: 1, borderRadius: oppSubReportName === "SSCPS Value of Safety Stock" ? "50px" : "0px", border: oppSubReportName === "SSCPS Value of Safety Stock" ? "2px solid #000" : "1px solid #fff", textAlign: 'center', cursor: 'pointer' }}>
                <p>SS by Source – Value</p>
              </div>
              <div onClick={() => setOppSubReportName("Safety Stock Value Difference")} style={{ flex: 1, borderRadius: oppSubReportName === "Safety Stock Value Difference" ? "50px" : "0px", border: oppSubReportName === "Safety Stock Value Difference" ? "2px solid #000" : "1px solid #fff", textAlign: 'center', cursor: 'pointer' }}>
                <p>S4 vs Final</p>
              </div>
              <div onClick={() => setOppSubReportName("Count of Safety Stock Master Data")} style={{ flex: 1, borderRadius: oppSubReportName === "Count of Safety Stock Master Data" ? "50px" : "0px", border: oppSubReportName === "Count of Safety Stock Master Data" ? "2px solid #000" : "1px solid #fff", textAlign: 'center', cursor: 'pointer' }}>
                <p>Manual SS Changes in S4</p>
              </div>
            </div>}
          <Box sx={{ flex: 1, p: 2 }}>
            <Paper
              sx={{
                height: "100%",
                borderRadius: 2,
                overflow: "hidden",
                position: "relative",
              }}
            >
              {loading ? (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : reportId && embedUrl && accessToken ? (
                <div>
                  <PowerBIEmbed
                    embedConfig={embedConfig}
                    cssClassName="powerBi_cls"
                  // cssClassName="report-style-class"
                  // getEmbeddedComponent={(embeddedReport) => {
                  //   console.log("Embedded report instance:", embeddedReport);
                  // }}
                  />
                </div>
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  No report available
                </Typography>
              )}
            </Paper>
          </Box>
        </div>
      </Box>
    </>
  );
};

export default AnalyticsPage;
